export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Отчеты: Поступившие документы",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
